var _excluded = ["className"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from 'react';
import ReactModal from 'react-modal';
import { jsx as ___EmotionJSX } from "@emotion/react";
export var ReactModalWrapper = function ReactModalWrapper(_ref) {
  var className = _ref.className,
    rest = _objectWithoutProperties(_ref, _excluded);
  var classArr = className ? className.split(' ') : ['__modal'];
  var append = function append(str) {
    return classArr.join(str + ' ') + str;
  };
  return ___EmotionJSX(ReactModal, _extends({
    closeTimeoutMS: 200,
    className: {
      base: append('__content'),
      afterOpen: append('__content--after-open'),
      beforeClose: append('__content--before-close')
    },
    portalClassName: append(''),
    overlayClassName: {
      base: append('__overlay '),
      afterOpen: append('__overlay--after-open'),
      beforeClose: append('__overlay--before-close')
    }
  }, rest));
};